import React, { useEffect, useState } from 'react'
import { ScrollView } from 'react-native'

import { HorizontalTagsLayout } from 'partials/WorkoutTags/subcomponents/HorizontalTagsLayout'

import { Box } from 'widgets/Box'
import { Modal } from 'widgets/Modal'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

import { useWorkoutTags } from 'hooks/useWorkoutTags'

import { TagGroup } from 'types/workoutTag'

import { WrapableTagsLayout } from './subcomponents/WrapableTagsLayout'

type WorkoutTagsModalProps = {
  isVisible: boolean
  isFilter?: boolean
  onClose: (selection?: any) => void
}

export const WorkoutTagsModal = ({ isVisible, onClose, isFilter }: WorkoutTagsModalProps) => {
  const { tags } = useWorkoutTags()

  const [isTagSelected, setIsTagSelected] = useState<boolean>(false)
  const [selectedWorkoutTypes, setSelectedWorkoutTypes] = useState<string[]>([])
  const [selectedMuscleGroup, setSelectedMuscleGroup] = useState<string[]>([])
  const [selectedDurations, setSelectedDurations] = useState<string[]>([])
  const [selectedLocations, setSelectedLocations] = useState<string[]>([])

  useEffect(() => {
    const isSelected =
      selectedWorkoutTypes.length !== 0 ||
      selectedMuscleGroup.length !== 0 ||
      selectedDurations.length !== 0 ||
      selectedLocations.length !== 0
    setIsTagSelected(isSelected)
  }, [selectedWorkoutTypes, selectedMuscleGroup, selectedDurations, selectedLocations])

  const handleReset = () => {
    setSelectedWorkoutTypes([])
    setSelectedMuscleGroup([])
    setSelectedDurations([])
    setSelectedLocations([])
  }

  const toggleSelection = (index: number, tag: TagGroup, selected: string[], setSelected: any) => {
    const item = tag.tags[index]
    if (!isFilter && tag.maxSelection === 1) {
      setSelected([item])
      return
    }
    if (selected.includes(item)) {
      const filtered = selected.filter((a: string) => a !== item)
      setSelected(filtered)
      return
    }
    if (tag.maxSelection === undefined) {
      setSelected([...selected, item])
      return
    }
    if (isFilter || selected.length < tag.maxSelection) {
      setSelected([...selected, item])
    }
  }

  return (
    <Modal isVisible={isVisible} onClose={() => {}} variant='fullscreenNoContent'>
      <Box flex={1} backgroundColor='white'>
        <Box
          flexDirection='row'
          align='center'
          justifyContent='space-between'
          padding={{ vertical: 'lg', horizontal: 'md' }}
        >
          <Pressable onPress={isTagSelected ? handleReset : () => onClose(undefined)}>
            <Text color='greyDarker'>{isTagSelected ? 'Clear All' : 'Back'}</Text>
          </Pressable>
          <Pressable
            disabled={!isTagSelected}
            onPress={() =>
              onClose({
                workoutTypes: {
                  id: tags.workoutTypes.id,
                  name: tags.workoutTypes.name,
                  style: tags.workoutTypes.style,
                  maxSelection: tags.workoutTypes.maxSelection,
                  tags: selectedWorkoutTypes,
                },
                muscleGroup: {
                  id: tags.muscleGroup.id,
                  name: tags.muscleGroup.name,
                  style: tags.muscleGroup.style,
                  maxSelection: tags.muscleGroup.maxSelection,
                  tags: selectedMuscleGroup,
                },
                duration: {
                  id: tags.durations.id,
                  name: tags.durations.name,
                  style: tags.durations.style,
                  maxSelection: tags.durations.maxSelection,
                  tags: selectedDurations,
                },
                location: {
                  id: tags.locations.id,
                  name: tags.locations.name,
                  style: tags.locations.style,
                  maxSelection: tags.locations.maxSelection,
                  tags: selectedLocations,
                },
              })
            }
          >
            <Text color={isTagSelected ? 'black' : 'grey'} bold>
              {isFilter ? 'Apply' : 'Done'}
            </Text>
          </Pressable>
        </Box>

        <ScrollView>
          <Box>
            <Box margin={{ top: 'xxs', horizontal: 'smd' }}>
              <WrapableTagsLayout
                data={tags.workoutTypes}
                selectedItems={selectedWorkoutTypes}
                onSelect={(index) =>
                  toggleSelection(
                    index,
                    tags.workoutTypes,
                    selectedWorkoutTypes,
                    setSelectedWorkoutTypes,
                  )
                }
              />
            </Box>

            <Box margin={{ top: 'md', horizontal: 'smd' }}>
              <WrapableTagsLayout
                data={tags.muscleGroup}
                selectedItems={selectedMuscleGroup}
                onSelect={(index) =>
                  toggleSelection(
                    index,
                    tags.muscleGroup,
                    selectedMuscleGroup,
                    setSelectedMuscleGroup,
                  )
                }
              />
            </Box>

            <Box margin={{ top: 'md', horizontal: 'smd' }}>
              <HorizontalTagsLayout
                data={tags.durations}
                selectedItems={selectedDurations}
                onSelect={(index) =>
                  toggleSelection(index, tags.durations, selectedDurations, setSelectedDurations)
                }
              />
            </Box>

            <Box margin={{ top: 'md', horizontal: 'smd' }}>
              <WrapableTagsLayout
                data={tags.locations}
                selectedItems={selectedLocations}
                onSelect={(index) =>
                  toggleSelection(index, tags.locations, selectedLocations, setSelectedLocations)
                }
              />
            </Box>
          </Box>
        </ScrollView>
      </Box>
    </Modal>
  )
}
